"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextUpdateSchema = exports.TextCreateSchema = exports.TextListResponseSchema = exports.TextListQuerySchema = exports.TextDetailSchema = exports.TextSummarySchema = void 0;
const zod_1 = require("zod");
exports.TextSummarySchema = zod_1.z.object({
    textId: zod_1.z.number(),
    title: zod_1.z.string().nullable(),
    code: zod_1.z.string().nullable(),
    registerNumber: zod_1.z.string().nullable(),
    state: zod_1.z.number().nullable(),
    typeId: zod_1.z.number().nullable(),
    priorityId: zod_1.z.number().nullable(),
    creatorId: zod_1.z.number().nullable(),
    createDate: zod_1.z.string().nullable(),
    publishDate: zod_1.z.string().nullable(),
    documentId: zod_1.z.number().nullable(),
});
exports.TextDetailSchema = exports.TextSummarySchema.extend({
    description: zod_1.z.string().nullable(),
    officeSender: zod_1.z.string().nullable(),
    cancelReason: zod_1.z.string().nullable(),
    recieverPlace: zod_1.z.string().nullable(),
    signLevel: zod_1.z.number().nullable(),
    isEncrypt: zod_1.z.boolean(),
});
exports.TextListQuerySchema = zod_1.z.object({
    page: zod_1.z.coerce.number().int().min(1).default(1),
    pageSize: zod_1.z.coerce.number().int().min(1).max(200).default(50),
    q: zod_1.z.string().trim().optional(),
    state: zod_1.z.coerce.number().int().optional(),
    typeId: zod_1.z.coerce.number().int().optional(),
    creatorId: zod_1.z.coerce.number().int().optional(),
    fromDate: zod_1.z.string().optional(),
    toDate: zod_1.z.string().optional(),
});
exports.TextListResponseSchema = zod_1.z.object({
    items: zod_1.z.array(exports.TextSummarySchema),
    total: zod_1.z.number(),
    page: zod_1.z.number(),
    pageSize: zod_1.z.number(),
});
exports.TextCreateSchema = zod_1.z.object({
    title: zod_1.z.string().min(1).max(500),
    description: zod_1.z.string().optional(),
    code: zod_1.z.string().optional(),
    registerNumber: zod_1.z.string().optional(),
    typeId: zod_1.z.number().int().optional(),
    priorityId: zod_1.z.number().int().optional(),
    officeSender: zod_1.z.string().optional(),
    documentId: zod_1.z.number().int().optional(),
});
exports.TextUpdateSchema = exports.TextCreateSchema.partial().extend({
    state: zod_1.z.number().int().optional(),
    cancelReason: zod_1.z.string().optional(),
    signLevel: zod_1.z.number().int().optional(),
});
